(function (angular) {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:pagination
     * @description
     * Componente para la paginación. Se modifica el parámetro :page del estado.
     *
     * El nº de elementos por página va en una constante ({@link app.object:public_constants}).
     *
     * @param {number} currentPage Página activa
     * @param {number} totalElements Número total de elementos
     * @param {boolean} separador Se añade un div con clase `separador`.
     *
     */
    angular
        .module('app')
        .component('pagination', {
            bindings: {
                currentPage: '<',
                totalElements: '<',
                separador: '<'
            },
            templateUrl: 'app/components/pagination/pagination.html',
            controller: function ($state, $stateParams, NG_LIST_DEFAULT_PARAMS_PUBLIC) {
                var vm = this;

                vm.itemsPerPage = NG_LIST_DEFAULT_PARAMS_PUBLIC.size;

                vm.pageChanged = function () {
                    var params = angular.copy($stateParams);
                    params.page = vm.currentPage;
                    $state.go($state.current, params);
                };
            },
            controllerAs: 'ctrl'
        });

})(angular);
